import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Row, Container } from 'react-bootstrap';
import Button from '../../../components/Button';

function FullDescription() {
  return (
    <Container className={'p-0'}>
      <Row>
        <Col className={'d-none d-lg-block p-0 mt-11 mb-12'}>
          <a
            href={`${
              process.env.PUBLIC_URL
            }/${'interlink-pension-checklist.pdf'}`}
            target={'_blank'}
            rel="noreferrer"
          >
            <Button
              onClick={() => console.log('Download/Print')}
              className={'m-0 ms-5'}
              variant="primary"
              rightIcon={light('file-arrow-down')}
            >
              Download/Print
            </Button>
          </a>
        </Col>
      </Row>
      <Row>
        <Col className={'col-12 d-lg-none mt-5 mb-13'}>
          <img
            className={'d-block mx-auto w-100 '}
            alt={'Pension election checklist'}
            src={`${process.env.PUBLIC_URL}/${'benefit-img.svg'}`}
          ></img>
        </Col>
      </Row>

      <Row>
        <Col className={'col-12 d-lg-none mb-5'}>
          <h5 className={'text-nowrap text-sm-20-lg-24'}>Checklist</h5>
        </Col>
      </Row>
      <Row>
        <Col className={'text-fs-6 lh-xs'}>
          <p>To report your Benefit Commencement, you will need:</p>
          <p className={'ms-10'}>
            If you are retiring from active employment your termination date –
            your last day of work. Current marital status, marriage date,
            spouse's birth date and Joint Annuitant's birth date, if applicable
          </p>
          <p>Other items to review</p>
          <ul className={'ps-10'}>
            <li>
              Review tax considerations and optional forms of payment with your
              tax or financial advisor. You may also access the U.S.
              Government's Pension Benefit Guaranty Corporation (PBGC) site for
              general information about choosing a lump sum or annuity payments.
            </li>
            <li>
              Review your Health & Welfare options by accessing the tab along
              the top of the site page.
            </li>
            <li>
              You must complete the process and provide the required
              documentation. If your completed materials are submitted after the
              Processing Deadline indicated your first payment may be delayed.
            </li>
            <li>
              If you do not complete the process and supply requested materials
              prior to the expiration date indicated, you will need to begin the
              Benefit Commencement process again in order to commence your
              benefit.
            </li>
            <li>
              Proof of birth date for yourself. If you elect a Joint & Survivor
              payment option, you must also provide proof of birth date for your
              designated Joint Annuitant. Acceptable forms of proof of birth
              date are a Birth Certificate, passport, or driver's license. If a
              Birth Certificate, passport or driver's license cannot be provided
              for yourself or your Joint Annuitant, you must provide two proofs
              of age from the following options:
            </li>

            <ul className={'ps-10 list-bullet-disc'}>
              <li>Military Record</li>
              <li>
                Marriage records showing birth date/divorce decree or age (e.g.,
                application for marriage license or church record, certified by
                the custodian of such records, or Marriage Certificate)
              </li>
              <li>
                Baptismal Certificate, or a church record which shows the birth
                date, and is certified by the custodian of such record
              </li>
              <li>
                Notification of registration of birth in a public registry of
                vital statistics
              </li>
              <li>
                Hospital birth record, certified by the custodian of such
                records
              </li>
              <li>
                Official document showing approval of a Social Security pension
              </li>
              <li>Birth record of a foreign church or government</li>
              <li>Naturalization record</li>
              <li>Immigration papers</li>
              <li>School record, certified by custodian of such records</li>
              <li>
                Vaccination record, certified by custodian of such records
              </li>
              <li>Insurance policy which shows the age or birth date</li>
              <li>
                Other evidence, such as signed statements from person who have
                knowledge of the birth date, voting records, and poll tax
                receipt
              </li>
            </ul>

            <li>
              Marriage Certificate if you are legally married. If a Marriage
              Certificate cannot be provided, other acceptable proof of marriage
              includes a church, synagogue or public record of marriage.
            </li>
            <li>
              Divorce decree and/or a copy of your Qualified Domestic Relations
              Order (QDRO) if not already on file.
            </li>
            <li>
              f you reside in a state that recognizes Common Law Marriage, you
              are married and meet the requirements, proof must be provided in
              the form of a notarized affidavit signed by you and your spouse,
              plus at least three notarized affidavits from unrelated parties
              confirming your marriage. You will also need to submit additional
              evidence confirming your marriage. ,<br /> Examples are:
              <ul className={'ps-10 list-bullet-disc'}>
                <li>Joint tax returns</li>
                <li>Insurance contracts</li>
                <li>Real estate deeds</li>
                <li>Joint bank accounts</li>
              </ul>
            </li>
            <li>Property tax statements</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default FullDescription;
